import AboutUsPage from "@pages/AboutUsPage/AboutUs.page";
import ArticlesPage from "@pages/ArticlePage/Articles.page";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Layout from "./layout";
import HomePage from "./pages/HomePage/Home.page";

gsap.registerPlugin(ScrollTrigger);

function App() {
    const location = useLocation();
    const containerRef = useRef();

    const routes = [
        { route: "/", Component: HomePage, isExact: true },
        { route: "/o-nas/", Component: AboutUsPage, isExact: true },
        { route: "/artykuly/*", Component: ArticlesPage },
    ];

    // Refresh ScrollTrigger when location changes (with debounce)
    useEffect(() => {
        const timer = setTimeout(() => {
            ScrollTrigger.refresh();
        }, 300);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    return (
        <Layout ref={containerRef}>
            <TransitionGroup>
                <CSSTransition
                    key={location.pathname}
                    classNames="page"
                    timeout={600}
                    onEnter={(node) => {
                        // Simple fade in
                        gsap.set(node, { opacity: 0 });
                    }}
                    onEntered={(node) => {
                        // Fade in the page
                        gsap.to(node, {
                            opacity: 1,
                            duration: 0.3,
                            ease: "power1.out",
                        });
                    }}
                    onExit={(node) => {
                        // Quick fade out
                        gsap.to(node, {
                            opacity: 0,
                            duration: 0.2,
                            ease: "power1.in",
                        });
                    }}
                >
                    <div className="page">
                        <Routes location={location}>
                            {routes.map(({ route, Component, isExact }, i) => (
                                <Route
                                    key={`route ${i}`}
                                    path={route}
                                    element={<Component />}
                                />
                            ))}
                            <Route
                                path="*"
                                element={<Navigate to="/" replace />}
                            />
                        </Routes>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Layout>
    );
}

export default App;
